import { createSelector } from "reselect";

import { AppState, CustomerSraDepartment } from "@teamprevent/common/customerSraDepartment/model";

import { CustomerState } from "../customer";
import { routeIdSelector as customerIdSelector } from "../customer/selectors";

export const routeIdSelector = (state: AppState) => {
    return state.router.params.customerSraDepartmentId;
};

export type SelectorState = AppState & CustomerState;

export const customerSraDepartmentsSelector = (state: SelectorState) => {
    const customerId = customerIdSelector(state);
    let customerSraDepartments = state.customerSraDepartments;

    customerSraDepartments = customerSraDepartments.filter(p => p.customerId === customerId);
    return customerSraDepartments;
};

export const customerSraDepartmentSelector = createSelector(
    customerSraDepartmentsSelector,
    routeIdSelector,
    (customerSraDepartments: CustomerSraDepartment[], id: any) => {
        return customerSraDepartments.filter(c => c.id === id)[0] || {} as CustomerSraDepartment;
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname.substring(0, state.router.pathname.indexOf("customerSraDepartments") + "customerSraDepartments".length);
